import {RequestBuilder} from '../request_builder'

export class WithdrawalUSDTRequestBuilder extends RequestBuilder {
  urlSegment (segment) {
    this.segment = segment
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/witdrawal_usdt_request_builder.js